export interface IPostalCodeAreas {
  city?: string;
  country?: string;
  district?: string;
  latitude?: any;
  line1?: string;
  line2?: string;
  longitude?: any;
  matched?: IPostals;
  postal_code?: string;
  province?: string;
  street_name?: string;
  street_number?: string;
  suburb?: string;
  postal_codes_sa02?: IPostalCodeArea[];
  unmatched?: IPostals;
}
export interface IPostals {
  mnfg?: IPostalDetails[];
  sa02?: IPostalDetails[];
  sapo?: IPostalDetails[];
}
export interface IPostalDetails {
  postal_code?: string;
  postal_code_id?: string;
  score?: number;
  suburb_name?: string;
}

export interface IPostalCodeArea {
  id?: string;
  postal_code_id: string;
  postal_code: string;
  suburb_name: string;
  insurer_id: string;
  ctrl_id: string;
  text?: string;
}

// Firebase object
// ctrl_id: "1911:Abner-On-Vaal"
// id: "1911:Abner-On-Vaal:0019_SAPO"
// insurer_id: "1911:Abner-On-Vaal:0019"
// postalCode: "1911"
// postalCodeId: "1911:Abner-On-Vaal:0019_SAPO"
// suburbName: "Abner-On-Vaal"
// text: "Abner-On-Vaal"

export interface IPostalCodes {
  SA02?: IPostalCodeArea;
  MNFG?: IPostalCodeArea;
  SAPO?: IPostalCodeArea;
}
